import React from 'react';
import { Typography, Link } from '@mui/material';

export default function ApiGuidelines() {
  return (
    <Typography variant="body1" component="span" sx={{ color: '#666666' }}>
      Visit our{' '}
      <Link
        href={process.env.REACT_APP_API_DOCS_URL}
        sx={{ color: '#666666', borderBottom: '1px solid', borderColor: '#6c6c6c', textDecoration: 'none' }}
        target="_blank"
      >
        developer docs
      </Link>{' '}
      for usage guidelines.
    </Typography>
  );
}
